import { Box, Button, Typography } from "@mui/material";
import { FC, useEffect, useState } from "react";
import _ from "lodash";
import "./LogOutPopUp.scss";
import CustomPopup from "../../../components/CustomPopup/CustomPopup";
import CommonGifAnimation from "../../../components/CustomGifAnimation/CommonGifAnimation";
import {
  T_AnimationData,
  T_CustomerLobDetails,
  T_LogoutInfoToBePassed,
  T_UserProfile,
} from "../../../globalTypes/GlobalTypes";
import { useLazyLogoutApiQuery } from "../GeneralAppElements_Api";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../redux-store/CustomReduxHooks";
import { useLocation } from "react-router-dom";
import ExclamationMarkGif from "../../../assets/gif/Exclamation_Mark.json";
import { getLogoutInfo } from "../../../utils/helper";
import { T_GenerateTokenRes } from "../../Feature_Login/Login_Types";
import CustomThreeDotsLoader from "../../../components/CustomThreeDotsLoader/CustomThreeDotsLoader";
import { triggerCleverTapEvent } from "../../../utils/CleverTap";
import { CleverTapEventType } from "../../../utils/CleverTapConstant";
import { CT_ScreenEvntDtls } from "../../Feature_CleverTap/ScreenEvents/CleverTapEventDetails";
import { GTAScreenType, SCREEN_TYPE } from "../../../utils/constants";
import TriggerGTAEvent from "../../../utils/GTA";
import {
  eraseCookie,
  INTERNAL_AUTH_TOKEN,
} from "../../../utils/CSCookieHandler";
import { useAppTranslation } from "../../../hooks/useAppTranslation";

interface Props {
  open: boolean;
  handleOpen: Function;
}

const LogOutPopUp: FC<Props> = ({ open, handleOpen }) => {
  const tokenDetails = useAppSelector((state) => state.CsAppSlice.tokenDetails);
  const location = useLocation();
  const userDetails = useAppSelector((state) => state.CsAppSlice.userDetails);
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const { t } = useAppTranslation("common");
  const [getLogOutApi] = useLazyLogoutApiQuery();

  const handleClevertapEvent = (type: string) => {
    if (type === "Logout") {
      triggerCleverTapEvent("serv_logout_cta_click", {
        ScreenType: SCREEN_TYPE.generalAppType,
        ScreenName: "Servicing Logout Options Drawer Screen",
        isPrevPageNameRequired: true,
        ctaText: type,
      });
      TriggerGTAEvent("serv_logout_cta_click", {
        screen_type: GTAScreenType.DashboardScreenType,
        screen_name: "servicing_logout_options_drawer_screen",
        CTA_text: type,
      });
    } else if (type === "Not now") {
      triggerCleverTapEvent("serv_logout_cta_click", {
        ScreenType: SCREEN_TYPE.StockScreenType,
        ScreenName: "Servicing Logout Options Drawer Screen",
        isPrevPageNameRequired: true,
        ctaText: type,
      });
      TriggerGTAEvent("serv_logout_cta_click", {
        screen_type: GTAScreenType.DashboardScreenType,
        screen_name: "servicing_logout_options_drawer_screen",
        CTA_text: type,
      });
    }
  };

  const handleClosePopup = () => {
    handleClevertapEvent("Not now");
    handleOpen(false);
  };

  const logoutEvent = (event: any) => {
    event.preventDefault();
    handleClevertapEvent("Logout");
    setLoading(true);
    getLogOutApi({
      csUserId: "" + userDetails?.CS_USER_ID,
    }).then(async (res) => {
      const logoutExtraInfo = getLogoutInfo(
        tokenDetails as T_GenerateTokenRes,
        userDetails as T_UserProfile & T_CustomerLobDetails,
      );
      eraseCookie(INTERNAL_AUTH_TOKEN);
      dispatch({
        type: "USER_LOGOUT",
        payload: { ...logoutExtraInfo, clearLocalStorage: true },
      });
    });
  };

  useEffect(() => {
    triggerCleverTapEvent(CleverTapEventType.SCREEN_EVENT, {
      ScreenName: CT_ScreenEvntDtls.R_GAE.gaLogOutOptDrawer.screenName,
      ScreenType: SCREEN_TYPE.DashboardScreenType,
    });
  }, []);

  const renderSteps = () => {
    return (
      <Box>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          paddingTop={"1rem"}
        >
          <CommonGifAnimation
            width="20%"
            animationData={ExclamationMarkGif as T_AnimationData}
          />
        </Box>
        <Box marginTop="1.375rem">
          <Typography textAlign="center" variant="h5">
            {t("logOut.title")}
          </Typography>
          <Typography textAlign="center" marginTop="1.5rem">
            {t("logOut.subtitle")}
          </Typography>

          {loading ? (
            <CustomThreeDotsLoader />
          ) : (
            <>
              <Button
                fullWidth
                variant="contained"
                sx={{ marginTop: "1.5rem" }}
                className="continue-btn"
                onClick={logoutEvent}
              >
                {t("logOut.logOut")}
              </Button>
              <Typography
                textAlign="center"
                color="#c7222a"
                variant="h5"
                marginTop="1.125rem"
                onClick={handleClosePopup}
                sx={{
                  "&:hover": {
                    cursor: `pointer`,
                  },
                }}
              >
                {t("logOut.notNow")}
              </Typography>
            </>
          )}
        </Box>
      </Box>
    );
  };

  return (
    <CustomPopup
      open={open}
      handleOpen={handleClosePopup}
      className="logout-popup"
    >
      <Box>{renderSteps()}</Box>
    </CustomPopup>
  );
};

export default LogOutPopUp;
